import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';

import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';

import { useModal } from '../../../function/useModal';
import { ResponceDataType, ErrorCode } from '../../../ErrorCode';

import MessageDialog, { MessageDialogResponse } from '../../atoms/Dialog/MessageDialog';
import ConfirmDialog, { ConfirmDialogResponse } from '../../atoms/Dialog/ConfirmDialog';
import ItemComboBoxStr, { ComboBoxItemTypeS } from '../../atoms/ComboBox/ItemComboBoxStr';
import SimpleCalender from '../../atoms/Calendar/SimpleCalender';
import DateInput from '../../atoms/Calendar/DateInput';
import { SelectDataType } from './OffLineJudge';
import OffLineJudteFotter from './OffLineJudgeFooter';
import {
  GetOffLineJudgeData,
  OfflineJudgeDataType,
  CreateDevCombBoxItems,
  GetOffLineJudgeFileTimes,
  CreateTimeCombBoxItems,
  ExecuteCopyOffLineJudgeFile,
} from './OffLineJudge';
import { OffLineJudgeStyle, TableBaseStyle } from './OffLineJudgeStyle';
import { useHistory } from 'react-router-dom';
type OffLineJudgePageProps = {};

const OffLineJudgePage: React.FC<OffLineJudgePageProps> = () => {
  const history = useHistory();
  const { t } = useTranslation();
  const offLineJudgeStyle = OffLineJudgeStyle();
  const tableStyle = TableBaseStyle();

  const [offlineJudgeData, setOfflineJudgeData] = useState<OfflineJudgeDataType[]>([]); //デバイス情報データ

  const [selectDevComboBoxList, setSelectDevComboBoxList] = useState<ComboBoxItemTypeS[]>([]); //デバイスコンボボックス
  const [selectTimeComboBoxList, setSelectTimeComboBoxList] = useState<ComboBoxItemTypeS[]>([]); //時間コンボボックス
  const [buttonEnable, setButtonEnable] = useState<boolean>(true);
  const [selectData, setSelectData] = useState<SelectDataType>({
    devIndex: '0',
    selectDate: dayjs(new Date()).format('YYYY-MM-DD'),
    selectTime: '',
  });

  const [flgCfmDlg, actCfmDlg] = useModal<ConfirmDialogResponse>();
  const [flgMsgDlg, actMsgDlg] = useModal<MessageDialogResponse>();
  const [dlgmsg, setDlgmsg] = useState<string>('');

  const msgdlg = flgMsgDlg ? <MessageDialog dialog={actMsgDlg} message={dlgmsg} /> : null;

  const cfmdlg = flgCfmDlg ? (
    <ConfirmDialog
      dialog={actCfmDlg}
      message={dlgmsg}
      action={t('OffLineJudgePage.はい', 'はい')}
      cancel={t('OffLineJudgePage.いいえ', 'いいえ')}
    />
  ) : null;

  /**
   * 初期表示
   */
  useEffect(() => {
    upDatePage();
  }, []);

  /**
   * 時間コンボボックス更新
   */
  const upDateSelectTimeList = () => {
    setButtonEnable(false);
    let cmdList: ComboBoxItemTypeS[];
    GetOffLineJudgeFileTimes(selectData.devIndex, selectData.selectDate)
      .then((r: Date[]) => {
        if (r != null && r.length != 0) {
          cmdList = CreateTimeCombBoxItems(r);
        } else {
          cmdList = [];
        }
        if (cmdList.length != 0) {
          selectData.selectTime = cmdList[0].key;
          setSelectData((prev) => ({ ...prev, selectTime: cmdList[0].key }));
        }
        setSelectTimeComboBoxList([...cmdList]);
      })
      .catch((e) => {
        setDlgmsg(t('OffLineJudgePage.データ取得中にエラーが発生しました', 'データ取得中にエラーが発生しました'));
        actMsgDlg.open();
        console.error(['OffLineJudgePage - useEffect[selectData] - Error', e]);
      })
      .finally(() => {
        setButtonEnable(true);
      });
  };

  /**
   * 画面更新
   */
  const upDatePage = () => {
    let offlineList: OfflineJudgeDataType[] = [];
    let cmdList: ComboBoxItemTypeS[];
    let selectDevIndex = '0';
    let dt = dayjs(new Date()).format('YYYY-MM-DD');

    setButtonEnable(false);
    GetOffLineJudgeData()
      .then((r: OfflineJudgeDataType[]) => {
        offlineList = r;
        if (r.length !== 0) {
          cmdList = CreateDevCombBoxItems(r);
          selectDevIndex = cmdList[0].key;
        }

        console.debug(['OffLineJudgePage useEffect - result , cmdList', r, cmdList]);
        setOfflineJudgeData([...offlineList]);
        setSelectDevComboBoxList([...cmdList]);
        setSelectData({ devIndex: selectDevIndex, selectDate: dt, selectTime: '' });
        selectData.devIndex = selectDevIndex; //初期の時間を取得するのにここでセット
        changeCalendarValueAction(dt);
      })
      .catch((e) => {
        setDlgmsg(t('OffLineJudgePage.データ取得中にエラーが発生しました', 'データ取得中にエラーが発生しました'));
        actMsgDlg.open();
        console.error(['OffLineJudgePage - upDatePage - Error', e]);
        setSelectData({ devIndex: selectDevIndex, selectDate: dt, selectTime: '' });
        setOfflineJudgeData([]);
        setSelectDevComboBoxList([]);

        throw new Error('Page3Child Throw Error');
      })
      .finally(() => {
        setButtonEnable(true);
      });
  };

  /**
   * 機器選択変更Event
   * @param value
   */
  const onDevIndexSelectDataChange = (e: React.ChangeEvent<{ name?: string; value: unknown }>) => {
    const selectDevIndex = String(e.target.value);
    selectData.devIndex = selectDevIndex;
    upDateSelectTimeList();
  };
  /**
   * カレンダー値変更
   * @param value
   */
  const changeCalendarValueAction = (value: string) => {
    selectData.selectDate = value;
    selectData.selectTime = '';
    upDateSelectTimeList();
  };

  /**
   * 時間変更
   * @param value
   */
  const changeTimeValueAction = (e: React.ChangeEvent<{ name?: string; value: unknown }>) => {
    const selectTimeIndex = String(e.target.value);
    setSelectData((prev) => ({ ...prev, selectTime: selectTimeIndex }));
  };

  /**
   * 選択ボタンアクション
   */
  const selectAction = () => {
    if (selectData.selectTime === '') {
      setDlgmsg(t('OffLineJudgePage.時刻を設定してください', '時刻を設定してください'));
      actMsgDlg.open();
      return;
    }
    setDlgmsg(t('OffLineJudgePage.選択した内容で、実行しますか?', '選択した内容で、実行しますか?'));
    actCfmDlg
      .open()
      .apply((_) => {
        setButtonEnable(false);
        const devIndex = selectData.devIndex;
        const selectDate = `${selectData.selectDate} ${selectData.selectTime}`;
        ExecuteCopyOffLineJudgeFile(devIndex, selectDate)
          .then((r) => {
            if (r.ErrorCode !== ErrorCode.ERR_CODE_NONE) {
              setDlgmsg(
                t(
                  'OffLineJudgePage.オフライン判定実行中にエラーが発生しました',
                  'オフライン判定実行中にエラーが発生しました'
                )
              );
              actMsgDlg.open();
              console.error(r);
            } else {
              setDlgmsg(t('OffLineJudgePage.オフライン判定を開始しました', 'オフライン判定を開始しました'));
              actMsgDlg.open();
            }
          })
          .catch((e) => {
            console.error(e);
            setDlgmsg(t('OffLineJudgePage.オフライン判定を開始しました', 'オフライン判定を開始しました'));
            actMsgDlg.open();
          })
          .finally(() => {
            setButtonEnable(true);
          });
      })
      .cancel(() => {
        console.debug(t('OffLineJudgePage.キャンセル', 'キャンセル'));
      });
  };

  return (
    <>
      <Grid container justify="flex-start" spacing={1} direction="row" alignItems="center" style={{ margin: 2 }}>
        <Grid item xs={12}>
          <Paper elevation={3} classes={{ root: offLineJudgeStyle.paperRoot }}>
            <Table aria-label="a main table">
              <TableBody>
                <TableRow>
                  <TableCell className={tableStyle.headerCell} width={100}>
                    {t('OffLineJudgePage.機器', '機器')}
                  </TableCell>
                  <TableCell className={tableStyle.bodyCell}>
                    <ItemComboBoxStr
                      itemList={selectDevComboBoxList}
                      label={''}
                      value={selectData.devIndex}
                      onChangeEvent={onDevIndexSelectDataChange}
                    ></ItemComboBoxStr>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className={tableStyle.headerCell}>{t('OffLineJudgePage.計測日', '計測日')}</TableCell>
                  <TableCell className={tableStyle.bodyCell}>
                    <table>
                      <tr>
                        <td>
                          <DateInput
                            //labelCssString={classes.labelStyle}
                            initialValue={dayjs(selectData.selectDate).format('YYYY-MM-DD')}
                            label={''}
                            labelPosition={1}
                            onDateChange={changeCalendarValueAction}
                          ></DateInput>
                          {/* <SimpleCalender defaultValue={selectData.selectDate} onChange={changeCalendarValueAction} /> */}
                        </td>
                        <td>
                          <ItemComboBoxStr
                            itemList={selectTimeComboBoxList}
                            label={''}
                            value={selectData.selectTime}
                            onChangeEvent={changeTimeValueAction}
                          ></ItemComboBoxStr>
                        </td>
                      </tr>
                    </table>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </Paper>
        </Grid>
        <Grid item xs={12}>
          <OffLineJudteFotter onClickSelectButton={selectAction} buttonEnable={buttonEnable}></OffLineJudteFotter>
        </Grid>
      </Grid>
      {msgdlg}
      {cfmdlg}
    </>
  );
};

export default OffLineJudgePage;
